import styled, { css } from 'styled-components';

export const HeaderContainer = styled.div<{
  $canCollapse: boolean;
  $hasHeader: boolean;
}>`
  ${({ $hasHeader }) =>
    $hasHeader &&
    css`
      margin: ${({ theme }) =>
        `${theme.spacing(4)} ${theme.spacing(6)} ${theme.spacing(1)}`};
      padding: ${({ theme }) => `${theme.spacing(2)} 0`};
      border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
    `};

  ${({ $canCollapse, theme }) =>
    $canCollapse &&
    css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: ${theme.spacing(1)};
    `};
`;

export const IconButtonContainer = styled.span`
  color: ${({ theme }) => theme.palette.grey[600]};
  line-height: 62.5%;
`;

export const ChildrenContainer = styled.div<{ $hasExtraSpacing: boolean }>`
  padding-left: ${({ theme, $hasExtraSpacing }) =>
    $hasExtraSpacing ? theme.spacing(1) : 0};
`;

export const NewTaskContainer = styled.div<{ $hasExtraSpacing: boolean }>`
  padding-left: ${({ theme, $hasExtraSpacing }) =>
    theme.spacing($hasExtraSpacing ? 5 : 4)};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding-left: ${({ theme }) => theme.spacing(3.5)};
    `};
`;
